// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* body { */
  /* background-image: url(images10/bg.jpg);
    background-position: top center;
    background-repeat: repeat-x; */

  /* margin: 0px; */
  /* background-color: #d1d1d1; */
  /* overflow-x: hidden; */
/* } */

.bgCont {
  position: fixed;
  z-index: -1;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  display: none;
  
  /* -webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 20px, rgba(0, 0, 0, 1) 100px); */
  /* mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 20px, rgba(0, 0, 0, 1) 100px); */

}

.bg {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 1000px;
  height: 100%;
  /* min-height: 100%; */
  background-color: #dddddd;  
  /* background-color: #141414; */

  /* border-left: 13px solid #202020; */
  /* border-right: 13px solid #202020; */

  /* display: none; */
}



.bg2 {
  z-index: -1;
  /* background-color: rgb(224, 223, 223); */
  width: 550px;
  height: 100%;
  margin: 0 auto;
}

div {
  /* border: 3px solid rgb(128, 0, 128); */
}

/* ------links--------------------------------------------------- */

.style1 {
  font-family: "Dosis", serif;
  font-size: 18px;
  color: #333333;
  letter-spacing: 2px;
}

/* ------sans--------------------------------------------------- */

.shadBox {
  border: 2px solid;
  border-style: inset;
}

/* .style2c { */
.boldSans {
  font-family: "Convergence", serif;
  font-size: 11px;
  color: #000000;
  letter-spacing: 1px;
  line-height: 17px;
}

/* .style2 { */
.smallSans11 {
  font-family: "Dosis", serif;
  font-size: 11px;
  color: #000000;
  letter-spacing: 1px;
  line-height: 17px;
}

.smallSans14b {
  font-family: "Dosis", serif;
  font-size: 14px;
  color: #333333;
  letter-spacing: 1px;
  /* line-height: 17px; */
  line-height: 25px;
  text-align: justify;
  text-align-last: center;
}

.smallSans14Dark {
  font-family: "Abel", serif;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0px;
  line-height: 20px;
}

.smallSans14Dark a:link {
  text-decoration: none;
  color: #333333;
}

.smallSans14Dark a:visited {
  text-decoration: none;
  color: #333333;
}

.smallSans14Dark a:hover {
  text-decoration: underline;
  color: #333333;
}

.smallSans14Dark a:active {
  text-decoration: underline;
  color: #333333;
}

/* .style2d { */
.smallSans20 {
  font-family: "Abel", serif;
  font-size: 20px;
  color: #333333;
  letter-spacing: 1px;
  line-height: 20px;
}

/* ------serif--------------------------------------------------- */

/* .style4 { */
.serif13 {
  font-family: "Radley", serif;
  font-size: 13px;
  color: #333333;
  letter-spacing: 0px;
  margin-top: 8px;
  margin-bottom: 16px;
  text-align: justify;
  /* border: 3px solid rgb(0, 102, 128); */
}

.serif13b {
  font-family: "Radley", serif;
  font-size: 13px;
  color: #333333;
  letter-spacing: 0px;
  margin-top: 8px;
  margin-bottom: 16px;
  text-align: center;
  /* border: 3px solid rgb(0, 102, 128); */
}

.serif13Waking {
  font-family: "Radley", serif;
  font-size: 13px;
  color: #333333;
  letter-spacing: 0px;
  margin-top: 8px;
  margin-bottom: 16px;
  text-align: justify;
  /* border: 3px solid rgb(0, 102, 128); */
}

.serif13Light {
  font-family: "Radley", serif;
  font-size: 13px;
  color: #333333;
  letter-spacing: 0px;
  margin-top: 8px;
  margin-bottom: 16px;
  align: justify;
}

/* .style4b { */
.serif13Margin {
  font-family: "Radley", serif;
  font-size: 13px;
  color: #333333;
  letter-spacing: 0px;
  margin-top: 8px;
  margin-bottom: 16px;
  margin-right: 26px;
  /* border: 3px solid rgb(0, 102, 128); */
}

/* .style4c { */
.serif13Margin2 {
  font-family: "Radley", serif;
  font-size: 13px;
  color: #333333;
  letter-spacing: 0px;
  margin-top: 8px;
  margin-bottom: 16px;
  margin-left: 26px;
}

.serif13Margin3 {
  font-family: "Radley", serif;
  font-size: 13px;
  color: #333333;
  letter-spacing: 0px;
  margin-top: 8px;
  margin-bottom: 16px;
  margin-left: 0px;
  text-align: right;
  /* border: 3px solid rgb(128, 0, 128); */
}

.serif13Margin3b {
  font-family: "Radley", serif;
  font-size: 13px;
  color: #333333;
  letter-spacing: 0px;
  margin-top: 8px;
  margin-bottom: 16px;
  margin-right: 26px;
  text-align: right;
  /* border: 3px solid rgb(128, 0, 128); */
}

.printScript {
  font-family: "Radley", serif;
  font-size: 20px;
  color: #333333;
  letter-spacing: 0px;
}
/* .style4d {
    font-family: 'Radley', serif;
    font-size: 16px;
    color: #000000;
    letter-spacing:0px;
    margin-top:8px;
    margin-bottom:12px;
} */

/* .style7 {
    font-family: 'IM Fell English', serif;
    font-size: 20px;
    color: #000000;
    letter-spacing:0px;
    font-style: italic;
} */

/* ------italic small--------------------------------------------------- */

/* .style7b { */
.tinyItalicScript {
  font-family: "IM Fell English", serif;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0px;
  margin-top: 0px;
  font-style: italic;
}

/* ------thumb--------------------------------------------------- */

.thumb1 {
  float: left;
  margin-right: 5px;
  margin-bottom: 5px;
  /* background-color: #ffffff; */
  -moz-border-radius: 8px;
  -webkit-border-radius: 8px;
  border-radius: 8px;
  overflow: hidden;
  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),
    0 0 30px rgba(0, 0, 0, 0.9) inset;
  -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),
    0 0 30px rgba(0, 0, 0, 0.1) inset;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 30px rgba(0, 0, 0, 0.1) inset;
  padding: 0;
  text-indent: 0px;
  opacity: 0.8;
}

#apDiv1 {
  position: absolute;
  left: 39px;
  top: 42px;
  width: 28px;
  height: 22px;
  z-index: 1;
}

#apDiv2 {
  position: absolute;
  left: 14px;
  top: 19px;
  width: 48px;
  height: 20px;
  z-index: 1;
}

#apDiv3 {
  position: relative;
  left: 281px;
  top: 73px;
  width: 45px;
  height: 42px;
  z-index: 1;
}

blockquote.smallSans11 {
  margin-top: 1px;
  margin-bottom: 0px;
  margin-left: 8px;
  padding-left: 10px;
  margin: 0px;
  border-left: 1px solid #333333;
  text-align: justify;
}

p {
  line-height: 1.7;
  margin-top: 0px;
  margin-bottom: 4px;
  margin-left: 0px;
  margin-right: 0px;
}

.tab {
  margin-left: 22px;
}
.tab2 {
  margin-left: 35px;
}
.tab3 {
  margin-top: 9px;
  margin-left: 22px;
}

/* table.tdclass td {
    margin-top: 9px;
} */

#apDiv4 {
  position: relative;
  left: 319px;
  top: 1010px;
  width: 103px;
  height: 95px;
  z-index: 1;
}

/* #apDiv5 { */
#topGrad {
  position: fixed;
  left: 0;
  top: 0px;
  width: 100%;
  height: 9px;
  z-index: 1;
  
}

.scriptFont2 {
  font-family: "IM Fell English", serif;
  font-size: 13px;
  color: #000000;
  /* letter-spacing: 1px; */
  font-style: italic;
}

/* ------mobile shrink--------------------------------------------------- */

#mobile {
  display: none;
}

.mobile {
  display: none;
}

@media (max-width: 860px) {
  .browser {
    display: none;
  }
  #browser {
    display: none;
  }
  #mobile {
    display: flex;
  }
  .mobile {
    display: inline;
  }
}

#container2 {
  /* background-color: green; */
  width: 100%;
  height: 100%;
  height: 500px;
  max-width: 800px;
  margin: 0 auto;
}

#container3 {
  /* background-color: green; */
  width: 100%;
  height: 100%;
  height: 500px;
  max-width: 500px;
  margin: 0 auto;
}

.clearLine {
  clear: both;
}

.topDiv {
  /* border: 3px solid rgb(128, 0, 128); */
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  height: 26px;
  width: 100%;
}

.topDiv2 {
  /* border: 3px solid rgb(128, 0, 128); */
  margin-top: 20px;
  display: flex;
  justify-content: center;
  height: 26px;
  width: 100%;
}

.topDiv3 {
  /* border: 3px solid rgb(128, 0, 128); */
  margin-top: 6px;
  margin-bottom: 20px;

  display: flex;
  justify-content: center;
  text-align: center;
  height: 26px;
  width: 100%;
}

.topDiv4 {
  /* border: 3px solid rgb(128, 0, 128); */
  margin-top: 9px;
  display: flex;
  justify-content: center;
  height: 16px;
  width: 100%;
}

.topDiv5 {
  /* border: 3px solid rgb(128, 0, 128); */
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 3px;
  margin-bottom: 3px;
  height: 16px;
  width: 100%;
}

.topDiv6 {
  /* border: 3px solid rgb(128, 0, 128); */
  margin-top: 20px;
  display: flex;
  justify-content: center;
  text-align: center;
  /* height: 26px; */
  width: 100%;
}

.topDiv7 {
  /* border: 3px solid rgb(128, 0, 128); */
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 3px;
  margin-bottom: 3px;
  /* height: 16px; */
  width: 100%;
}

.bigSereph {
  font-family: "Radley", serif;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0px;
}

.headerSereph {
  font-family: "Radley", serif;
  font-size: 20px;
  color: #000000;
  letter-spacing: 0px;
}

.headerSereph2 {
  font-family: "Lora", serif;
  font-size: 12px;
  color: #000000;
  letter-spacing: 0px;
}

.headerSereph3 {
  font-family: "Lora", serif;
  font-size: 12px;
  color: #000000;
  letter-spacing: 1px;
}

.topDiv8 {
  /* border: 3px solid rgb(128, 0, 128); */
  margin-top: 20px;
  /* margin-left: 20px; */
  display: flex;
  justify-content: center;
  text-align: center;
  /* height: 26px; */
  width: 100%;
}

.topDiv9 {
  /* border: 3px solid rgb(128, 0, 128); */
  /* margin-top: 40px; */
  /* margin-left: 20px; */
  display: flex;
  justify-content: center;
  text-align: center;
  /* height: 26px; */
  width: 100%;
}

.imageDiv {
  /* border: 3px solid rgb(128, 0, 128); */
  /* display: flex; */
  /* display: flex; */
  /* justify-content: center; */
  margin: 0 auto;
  width: 100%;
  max-width: 800px;
  /* opacity: 0; */
}

.image800 {
  width: 100%;
  max-width: 800px;
}

.imageDiv {
  /* border: 3px solid rgb(128, 0, 128); */
  /* display: flex; */
  /* display: flex; */
  /* justify-content: center; */
  margin: 0 auto;
  width: 100%;
  max-width: 900px;
}

.image800r {
  width: 100%;
  max-width: 800px;

  float: left;
  margin-right: 5px;
  margin-bottom: 5px;
  /* background-color: #ffffff; */
  -moz-border-radius: 8px;
  -webkit-border-radius: 8px;
  border-radius: 8px;
  overflow: hidden;
  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),
    0 0 30px rgba(0, 0, 0, 0.1) inset;
  -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),
    0 0 30px rgba(0, 0, 0, 0.1) inset;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 30px rgba(0, 0, 0, 0.1) inset;
  padding: 0;
}

.imageDiv500 {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
  max-width: 800px;
}

.image500 {
  /* border: 3px solid rgb(128, 0, 128); */
  width: 100%;
  height: 100%;
  max-width: 400px;

  float: left;
  margin-right: 5px;
  margin-bottom: 5px;
  /* background-color: #ffffff; */
  -moz-border-radius: 8px;
  -webkit-border-radius: 8px;
  border-radius: 8px;
  overflow: hidden;
  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),
    0 0 30px rgba(0, 0, 0, 0.1) inset;
  -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),
    0 0 30px rgba(0, 0, 0, 0.1) inset;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 30px rgba(0, 0, 0, 0.1) inset;
  padding: 0;
}

.imageDiv600 {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
  max-width: 600px;
}

.image600 {
  /* border: 3px solid rgb(128, 0, 128); */
  width: 100%;
  height: 100%;
  max-width: 600px;

  float: left;
  margin-right: 5px;
  margin-bottom: 5px;
  /* background-color: #ffffff; */
  -moz-border-radius: 8px;
  -webkit-border-radius: 8px;
  border-radius: 8px;
  overflow: hidden;
  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),
    0 0 30px rgba(0, 0, 0, 0.1) inset;
  -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),
    0 0 30px rgba(0, 0, 0, 0.1) inset;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 30px rgba(0, 0, 0, 0.1) inset;
  padding: 0;
}

.imageHalf {
  width: 49.5%;
  padding: 1px;
  height: 50%;
  max-width: 400px;
}



.imageHalf450b {
  width: 50%;
  /* padding: 1px; */
  height: 50%;
  max-width: 450px;

  float: left;
  margin-left: 2px;
  margin-bottom: 5px;
  /* background-color: #ffffff; */
  -moz-border-radius: 8px;
  -webkit-border-radius: 8px;
  border-radius: 8px;
  overflow: hidden;
  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),
    0 0 30px rgba(0, 0, 0, 0.1) inset;
  -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),
    0 0 30px rgba(0, 0, 0, 0.1) inset;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 30px rgba(0, 0, 0, 0.1) inset;
  padding: 0;
}

.imageSix {
  width: 13%;
  padding: 1px;
  height: 15%;
  max-width: 136px;
}

.imageFour {
  width: 49.5%;
  padding: 1px;
  height: 50%;
  max-width: 200px;
}

.divHalf {
  /* border: 3px solid rgb(0, 128, 85); */
  overflow: hidden;
  width: 100%;
  display: flex;
  justify-content: center;
}

.divHalf2 {
  /* border: 3px solid rgb(0, 128, 85); */
  width: 100%;
  display: flex;
  justify-content: center;
}

.divHalf3 {
  /* border: 3px solid rgb(0, 128, 85); */
  width: 100%;
  display: flex;
  justify-content: justify;
}

.textDivPrint {
  /* border: 3px solid rgb(128, 0, 128); */
  /* position: absolute; */
  /* padding-left: 12px; */
  /* padding-right: 12px; */

  margin-top: 12px;
  margin-bottom: 12px;
  text-align: center;
  max-width: 800px;
  width: 100%;
}

.textDivPrint2 {
  margin-top: 12px;
  margin-bottom: 12px;
  text-align: justify;
  text-align-last: center;
  max-width: 800px;
  width: 100%;
}

.textDivPrint3 {
  margin: 0 auto;
  margin-top: 12px;
  margin-bottom: 12px;
  text-align: center;
  /* text-align-last: center; */
  max-width: 800px;
  width: 100%;
}


.textDi2 {
  /* border: 3px solid rgb(128, 0, 128); */
  /* position: absolute; */
  margin-left: 12px;
  margin-right: 12px;
  margin-top: 7px;
  margin-bottom: 0px;
  text-align: justify;
}

.textDivDark {
  /* border: 3px solid rgb(128, 0, 128); */
  /* position: absolute; */
  background-color: #333333;
  color: #cccccc;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 7px;
  padding-bottom: 7px;
  text-align: justify;
}



.textDivCenter3 {
  /* border: 3px solid rgb(128, 0, 128); */
  /* position: absolute; */
  width: 50%;
  margin-left: 12px;
  margin-right: 12px;
  text-align: center;
}

.textDivCenter4 {
  /* border: 3px solid rgb(128, 0, 128); */
  /* position: absolute; */
  width: 50%;
  /* margin-left: 12px; */
  margin-right: 12px;
  text-align: justify;
}

.textDivCenter2 {
  /* border: 3px solid rgb(128, 94, 0); */
  background-color: #333333;
  padding-top: 12px;
  padding-bottom: 12px;
  width: 50%;
  text-align: center;
}

.greyLine2 {
  width: 100%;
  height: 1px;
  background-color: rgb(150, 150, 150);
}

.greyLineBrowser {
  /* border: 3px solid rgb(128, 94, 0); */
  width: 900px;
  /* width: 100%; */
  height: 1px;
  /* padding-bottom: 1px; */
  background-color: rgb(150, 150, 150);
}

.iframeDiv {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  width: 100%;
  max-width: 900px;
}

.iframeVid {
  /* border: 2px soldid; */
  /* border-style: inset; */
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.videoCont {
  display: flex;
  margin: 0 auto;
  align-items: center;
  flex-direction: column;
  justify-content: top;
}

.videoDiv {
  position: relative;
  width: 100%;
  height: 578px;
  max-width: 900px;

  /* float: left;
  margin-right: 5px;
  margin-bottom: 5px;
  background-color: #ffffff;
  -moz-border-radius: 8px;
  -webkit-border-radius: 8px;
  border-radius: 8px;
  overflow: hidden;
  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),
    0 0 30px rgba(0, 0, 0, 0.1) inset;
  -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),
    0 0 30px rgba(0, 0, 0, 0.1) inset;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 30px rgba(0, 0, 0, 0.1) inset;
  padding: 0; */
}

.oldDiv {
  top: 110px;
  height: 25px;
  width: 100%;
  padding-top: 4px;
  /* position: absolute; */
  /* border: 3px solid rgb(128, 0, 128); */
  background-color: black;
  color: white;
  text-align: center;
}

#videoCont {
  display: flex;
  margin: 0 auto;
  align-items: center;
  flex-direction: column;
  justify-content: top;
}

#videoDiv {
  position: relative;
  width: 100%;
  /* height: 578px; */
  height: 506px;
  max-width: 900px;
  /* border: 3px solid rgb(128, 0, 128); */
}

#video {
  width: 100%;
  height: 100%;
}

@media (max-width: 700px) {
  #videoDiv {
    position: absolute;
    height: 100%;
  }
}

@media (max-width: 400px) {
  .divHalf {
    /* display: block; */
    flex-direction: column;
  }
  .textDivPrint3 {
    width: 95%;
  }
  .textDivCenter4 {
    margin-top: 10px;
  }
  .serif13Waking {
    font-size: 11px;
  }
  .imageHalf {
    width: 100%;
    max-width: 400px;
    padding: 0px;
    padding-top: 1px;
  }
  .imageHalf450 {
    width: 100%;
    max-width: 450px;
    margin: 0px;
    padding: 0px;
    padding-top: 1px;
    border-radius: 0px;
    border-radius: 0px;
    margin-right: 0px;
    margin-bottom: 2px;
    -moz-border-radius: 0px;
    -webkit-border-radius: 0px;
    border-radius: 0px;
  }
  .imageHalf450b {
    width: 100%;
    max-width: 450px;
    margin: 0px;
    padding: 0px;
    padding-top: 1px;
    border-radius: 0px;
    border-radius: 0px;
    margin-right: 0px;
    margin-bottom: 2px;
    -moz-border-radius: 0px;
    -webkit-border-radius: 0px;
    border-radius: 0px;
  }
  .textDivPrint2 {
    display: none;
  }
  .image800r {
    border-radius: 0px;
    border-radius: 0px;
    margin-right: 0px;
    margin-bottom: 2px;
    -moz-border-radius: 0px;
    -webkit-border-radius: 0px;
    border-radius: 0px;
  }
  .image500 {
    border-radius: 0px;
    margin-right: 0px;
    margin-bottom: 0px;
    -moz-border-radius: 0px;
    -webkit-border-radius: 0px;
    border-radius: 0px;
  }
  .image600 {
    border-radius: 0px;
    margin-right: 0px;
    margin-bottom: 2px;
    -moz-border-radius: 0px;
    -webkit-border-radius: 0px;
    border-radius: 0px;
  }
  
  .shadBox {
    border: 0px;
    border-style: none;
  }
  .textDivPrint {
    padding-left: 10px;
    /* padding-right: 12px; */
    width: 95%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles2.css"],"names":[],"mappings":"AAAA,WAAW;EACT;;kCAEgC;;EAEhC,iBAAiB;EACjB,+BAA+B;EAC/B,wBAAwB;AAC1B,MAAM;;AAEN;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,UAAU;EACV,aAAa;;EAEb,mGAAmG;EACnG,2FAA2F;;AAE7F;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;;EAE/B,qCAAqC;EACrC,sCAAsC;;EAEtC,mBAAmB;AACrB;;;;AAIA;EACE,WAAW;EACX,0CAA0C;EAC1C,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,mEAAmE;;AAEnE;EACE,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,kEAAkE;;AAElE;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,mEAAmE;;AAEnE,cAAc;AACd;EACE,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,eAAe;AACf;EACE,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;;;;;;;GAOG;;AAEH;;;;;;GAMG;;AAEH,0EAA0E;;AAE1E,eAAe;AACf;EACE,qCAAqC;EACrC,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA,mEAAmE;;AAEnE;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB;qCACmC;EACnC;qCACmC;EACnC,2EAA2E;EAC3E,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;;AAEA,cAAc;AACd;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,WAAW;EACX,WAAW;EACX,UAAU;;AAEZ;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,2EAA2E;;AAE3E;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,mBAAmB;;EAEnB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;;EAEhB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB;qCACmC;EACnC;qCACmC;EACnC,2EAA2E;EAC3E,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,WAAW;EACX,YAAY;EACZ,gBAAgB;;EAEhB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB;qCACmC;EACnC;qCACmC;EACnC,2EAA2E;EAC3E,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,WAAW;EACX,YAAY;EACZ,gBAAgB;;EAEhB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB;qCACmC;EACnC;qCACmC;EACnC,2EAA2E;EAC3E,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;;;AAIA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,gBAAgB;;EAEhB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB;qCACmC;EACnC;qCACmC;EACnC,2EAA2E;EAC3E,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,WAAW;EACX,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;;EAEzB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,WAAW;AACb;;;AAGA;EACE,wCAAwC;EACxC,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,wBAAwB;EACxB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;;;AAIA;EACE,wCAAwC;EACxC,wBAAwB;EACxB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,wBAAwB;EACxB,UAAU;EACV,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;;EAEhB;;;;;;;;;;;;;eAaa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,wCAAwC;EACxC,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;IAClB,YAAY;EACd;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;IAC1B,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;IAC1B,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;IAC1B,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;IAC1B,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;EACZ;AACF","sourcesContent":["/* body { */\r\n  /* background-image: url(images10/bg.jpg);\r\n    background-position: top center;\r\n    background-repeat: repeat-x; */\r\n\r\n  /* margin: 0px; */\r\n  /* background-color: #d1d1d1; */\r\n  /* overflow-x: hidden; */\r\n/* } */\r\n\r\n.bgCont {\r\n  position: fixed;\r\n  z-index: -1;\r\n  width: 100%;\r\n  height: 100%;\r\n  top: 0;\r\n  left: 0;\r\n  opacity: 0;\r\n  display: none;\r\n  \r\n  /* -webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 20px, rgba(0, 0, 0, 1) 100px); */\r\n  /* mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 20px, rgba(0, 0, 0, 1) 100px); */\r\n\r\n}\r\n\r\n.bg {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 1000px;\r\n  height: 100%;\r\n  /* min-height: 100%; */\r\n  background-color: #dddddd;  \r\n  /* background-color: #141414; */\r\n\r\n  /* border-left: 13px solid #202020; */\r\n  /* border-right: 13px solid #202020; */\r\n\r\n  /* display: none; */\r\n}\r\n\r\n\r\n\r\n.bg2 {\r\n  z-index: -1;\r\n  /* background-color: rgb(224, 223, 223); */\r\n  width: 550px;\r\n  height: 100%;\r\n  margin: 0 auto;\r\n}\r\n\r\ndiv {\r\n  /* border: 3px solid rgb(128, 0, 128); */\r\n}\r\n\r\n/* ------links--------------------------------------------------- */\r\n\r\n.style1 {\r\n  font-family: \"Dosis\", serif;\r\n  font-size: 18px;\r\n  color: #333333;\r\n  letter-spacing: 2px;\r\n}\r\n\r\n/* ------sans--------------------------------------------------- */\r\n\r\n.shadBox {\r\n  border: 2px solid;\r\n  border-style: inset;\r\n}\r\n\r\n/* .style2c { */\r\n.boldSans {\r\n  font-family: \"Convergence\", serif;\r\n  font-size: 11px;\r\n  color: #000000;\r\n  letter-spacing: 1px;\r\n  line-height: 17px;\r\n}\r\n\r\n/* .style2 { */\r\n.smallSans11 {\r\n  font-family: \"Dosis\", serif;\r\n  font-size: 11px;\r\n  color: #000000;\r\n  letter-spacing: 1px;\r\n  line-height: 17px;\r\n}\r\n\r\n.smallSans14b {\r\n  font-family: \"Dosis\", serif;\r\n  font-size: 14px;\r\n  color: #333333;\r\n  letter-spacing: 1px;\r\n  /* line-height: 17px; */\r\n  line-height: 25px;\r\n  text-align: justify;\r\n  text-align-last: center;\r\n}\r\n\r\n.smallSans14Dark {\r\n  font-family: \"Abel\", serif;\r\n  font-size: 14px;\r\n  color: #333333;\r\n  letter-spacing: 0px;\r\n  line-height: 20px;\r\n}\r\n\r\n.smallSans14Dark a:link {\r\n  text-decoration: none;\r\n  color: #333333;\r\n}\r\n\r\n.smallSans14Dark a:visited {\r\n  text-decoration: none;\r\n  color: #333333;\r\n}\r\n\r\n.smallSans14Dark a:hover {\r\n  text-decoration: underline;\r\n  color: #333333;\r\n}\r\n\r\n.smallSans14Dark a:active {\r\n  text-decoration: underline;\r\n  color: #333333;\r\n}\r\n\r\n/* .style2d { */\r\n.smallSans20 {\r\n  font-family: \"Abel\", serif;\r\n  font-size: 20px;\r\n  color: #333333;\r\n  letter-spacing: 1px;\r\n  line-height: 20px;\r\n}\r\n\r\n/* ------serif--------------------------------------------------- */\r\n\r\n/* .style4 { */\r\n.serif13 {\r\n  font-family: \"Radley\", serif;\r\n  font-size: 13px;\r\n  color: #333333;\r\n  letter-spacing: 0px;\r\n  margin-top: 8px;\r\n  margin-bottom: 16px;\r\n  text-align: justify;\r\n  /* border: 3px solid rgb(0, 102, 128); */\r\n}\r\n\r\n.serif13b {\r\n  font-family: \"Radley\", serif;\r\n  font-size: 13px;\r\n  color: #333333;\r\n  letter-spacing: 0px;\r\n  margin-top: 8px;\r\n  margin-bottom: 16px;\r\n  text-align: center;\r\n  /* border: 3px solid rgb(0, 102, 128); */\r\n}\r\n\r\n.serif13Waking {\r\n  font-family: \"Radley\", serif;\r\n  font-size: 13px;\r\n  color: #333333;\r\n  letter-spacing: 0px;\r\n  margin-top: 8px;\r\n  margin-bottom: 16px;\r\n  text-align: justify;\r\n  /* border: 3px solid rgb(0, 102, 128); */\r\n}\r\n\r\n.serif13Light {\r\n  font-family: \"Radley\", serif;\r\n  font-size: 13px;\r\n  color: #333333;\r\n  letter-spacing: 0px;\r\n  margin-top: 8px;\r\n  margin-bottom: 16px;\r\n  align: justify;\r\n}\r\n\r\n/* .style4b { */\r\n.serif13Margin {\r\n  font-family: \"Radley\", serif;\r\n  font-size: 13px;\r\n  color: #333333;\r\n  letter-spacing: 0px;\r\n  margin-top: 8px;\r\n  margin-bottom: 16px;\r\n  margin-right: 26px;\r\n  /* border: 3px solid rgb(0, 102, 128); */\r\n}\r\n\r\n/* .style4c { */\r\n.serif13Margin2 {\r\n  font-family: \"Radley\", serif;\r\n  font-size: 13px;\r\n  color: #333333;\r\n  letter-spacing: 0px;\r\n  margin-top: 8px;\r\n  margin-bottom: 16px;\r\n  margin-left: 26px;\r\n}\r\n\r\n.serif13Margin3 {\r\n  font-family: \"Radley\", serif;\r\n  font-size: 13px;\r\n  color: #333333;\r\n  letter-spacing: 0px;\r\n  margin-top: 8px;\r\n  margin-bottom: 16px;\r\n  margin-left: 0px;\r\n  text-align: right;\r\n  /* border: 3px solid rgb(128, 0, 128); */\r\n}\r\n\r\n.serif13Margin3b {\r\n  font-family: \"Radley\", serif;\r\n  font-size: 13px;\r\n  color: #333333;\r\n  letter-spacing: 0px;\r\n  margin-top: 8px;\r\n  margin-bottom: 16px;\r\n  margin-right: 26px;\r\n  text-align: right;\r\n  /* border: 3px solid rgb(128, 0, 128); */\r\n}\r\n\r\n.printScript {\r\n  font-family: \"Radley\", serif;\r\n  font-size: 20px;\r\n  color: #333333;\r\n  letter-spacing: 0px;\r\n}\r\n/* .style4d {\r\n    font-family: 'Radley', serif;\r\n    font-size: 16px;\r\n    color: #000000;\r\n    letter-spacing:0px;\r\n    margin-top:8px;\r\n    margin-bottom:12px;\r\n} */\r\n\r\n/* .style7 {\r\n    font-family: 'IM Fell English', serif;\r\n    font-size: 20px;\r\n    color: #000000;\r\n    letter-spacing:0px;\r\n    font-style: italic;\r\n} */\r\n\r\n/* ------italic small--------------------------------------------------- */\r\n\r\n/* .style7b { */\r\n.tinyItalicScript {\r\n  font-family: \"IM Fell English\", serif;\r\n  font-size: 14px;\r\n  color: #333333;\r\n  letter-spacing: 0px;\r\n  margin-top: 0px;\r\n  font-style: italic;\r\n}\r\n\r\n/* ------thumb--------------------------------------------------- */\r\n\r\n.thumb1 {\r\n  float: left;\r\n  margin-right: 5px;\r\n  margin-bottom: 5px;\r\n  /* background-color: #ffffff; */\r\n  -moz-border-radius: 8px;\r\n  -webkit-border-radius: 8px;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),\r\n    0 0 30px rgba(0, 0, 0, 0.9) inset;\r\n  -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),\r\n    0 0 30px rgba(0, 0, 0, 0.1) inset;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 30px rgba(0, 0, 0, 0.1) inset;\r\n  padding: 0;\r\n  text-indent: 0px;\r\n  opacity: 0.8;\r\n}\r\n\r\n#apDiv1 {\r\n  position: absolute;\r\n  left: 39px;\r\n  top: 42px;\r\n  width: 28px;\r\n  height: 22px;\r\n  z-index: 1;\r\n}\r\n\r\n#apDiv2 {\r\n  position: absolute;\r\n  left: 14px;\r\n  top: 19px;\r\n  width: 48px;\r\n  height: 20px;\r\n  z-index: 1;\r\n}\r\n\r\n#apDiv3 {\r\n  position: relative;\r\n  left: 281px;\r\n  top: 73px;\r\n  width: 45px;\r\n  height: 42px;\r\n  z-index: 1;\r\n}\r\n\r\nblockquote.smallSans11 {\r\n  margin-top: 1px;\r\n  margin-bottom: 0px;\r\n  margin-left: 8px;\r\n  padding-left: 10px;\r\n  margin: 0px;\r\n  border-left: 1px solid #333333;\r\n  text-align: justify;\r\n}\r\n\r\np {\r\n  line-height: 1.7;\r\n  margin-top: 0px;\r\n  margin-bottom: 4px;\r\n  margin-left: 0px;\r\n  margin-right: 0px;\r\n}\r\n\r\n.tab {\r\n  margin-left: 22px;\r\n}\r\n.tab2 {\r\n  margin-left: 35px;\r\n}\r\n.tab3 {\r\n  margin-top: 9px;\r\n  margin-left: 22px;\r\n}\r\n\r\n/* table.tdclass td {\r\n    margin-top: 9px;\r\n} */\r\n\r\n#apDiv4 {\r\n  position: relative;\r\n  left: 319px;\r\n  top: 1010px;\r\n  width: 103px;\r\n  height: 95px;\r\n  z-index: 1;\r\n}\r\n\r\n/* #apDiv5 { */\r\n#topGrad {\r\n  position: fixed;\r\n  left: 0;\r\n  top: 0px;\r\n  width: 100%;\r\n  height: 9px;\r\n  z-index: 1;\r\n  \r\n}\r\n\r\n.scriptFont2 {\r\n  font-family: \"IM Fell English\", serif;\r\n  font-size: 13px;\r\n  color: #000000;\r\n  /* letter-spacing: 1px; */\r\n  font-style: italic;\r\n}\r\n\r\n/* ------mobile shrink--------------------------------------------------- */\r\n\r\n#mobile {\r\n  display: none;\r\n}\r\n\r\n.mobile {\r\n  display: none;\r\n}\r\n\r\n@media (max-width: 860px) {\r\n  .browser {\r\n    display: none;\r\n  }\r\n  #browser {\r\n    display: none;\r\n  }\r\n  #mobile {\r\n    display: flex;\r\n  }\r\n  .mobile {\r\n    display: inline;\r\n  }\r\n}\r\n\r\n#container2 {\r\n  /* background-color: green; */\r\n  width: 100%;\r\n  height: 100%;\r\n  height: 500px;\r\n  max-width: 800px;\r\n  margin: 0 auto;\r\n}\r\n\r\n#container3 {\r\n  /* background-color: green; */\r\n  width: 100%;\r\n  height: 100%;\r\n  height: 500px;\r\n  max-width: 500px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.clearLine {\r\n  clear: both;\r\n}\r\n\r\n.topDiv {\r\n  /* border: 3px solid rgb(128, 0, 128); */\r\n  margin-top: 20px;\r\n  margin-bottom: 20px;\r\n  display: flex;\r\n  justify-content: center;\r\n  height: 26px;\r\n  width: 100%;\r\n}\r\n\r\n.topDiv2 {\r\n  /* border: 3px solid rgb(128, 0, 128); */\r\n  margin-top: 20px;\r\n  display: flex;\r\n  justify-content: center;\r\n  height: 26px;\r\n  width: 100%;\r\n}\r\n\r\n.topDiv3 {\r\n  /* border: 3px solid rgb(128, 0, 128); */\r\n  margin-top: 6px;\r\n  margin-bottom: 20px;\r\n\r\n  display: flex;\r\n  justify-content: center;\r\n  text-align: center;\r\n  height: 26px;\r\n  width: 100%;\r\n}\r\n\r\n.topDiv4 {\r\n  /* border: 3px solid rgb(128, 0, 128); */\r\n  margin-top: 9px;\r\n  display: flex;\r\n  justify-content: center;\r\n  height: 16px;\r\n  width: 100%;\r\n}\r\n\r\n.topDiv5 {\r\n  /* border: 3px solid rgb(128, 0, 128); */\r\n  display: flex;\r\n  justify-content: center;\r\n  text-align: center;\r\n  margin-top: 3px;\r\n  margin-bottom: 3px;\r\n  height: 16px;\r\n  width: 100%;\r\n}\r\n\r\n.topDiv6 {\r\n  /* border: 3px solid rgb(128, 0, 128); */\r\n  margin-top: 20px;\r\n  display: flex;\r\n  justify-content: center;\r\n  text-align: center;\r\n  /* height: 26px; */\r\n  width: 100%;\r\n}\r\n\r\n.topDiv7 {\r\n  /* border: 3px solid rgb(128, 0, 128); */\r\n  display: flex;\r\n  justify-content: center;\r\n  text-align: center;\r\n  margin-top: 3px;\r\n  margin-bottom: 3px;\r\n  /* height: 16px; */\r\n  width: 100%;\r\n}\r\n\r\n.bigSereph {\r\n  font-family: \"Radley\", serif;\r\n  font-size: 40px;\r\n  color: #000000;\r\n  letter-spacing: 0px;\r\n}\r\n\r\n.headerSereph {\r\n  font-family: \"Radley\", serif;\r\n  font-size: 20px;\r\n  color: #000000;\r\n  letter-spacing: 0px;\r\n}\r\n\r\n.headerSereph2 {\r\n  font-family: \"Lora\", serif;\r\n  font-size: 12px;\r\n  color: #000000;\r\n  letter-spacing: 0px;\r\n}\r\n\r\n.headerSereph3 {\r\n  font-family: \"Lora\", serif;\r\n  font-size: 12px;\r\n  color: #000000;\r\n  letter-spacing: 1px;\r\n}\r\n\r\n.topDiv8 {\r\n  /* border: 3px solid rgb(128, 0, 128); */\r\n  margin-top: 20px;\r\n  /* margin-left: 20px; */\r\n  display: flex;\r\n  justify-content: center;\r\n  text-align: center;\r\n  /* height: 26px; */\r\n  width: 100%;\r\n}\r\n\r\n.topDiv9 {\r\n  /* border: 3px solid rgb(128, 0, 128); */\r\n  /* margin-top: 40px; */\r\n  /* margin-left: 20px; */\r\n  display: flex;\r\n  justify-content: center;\r\n  text-align: center;\r\n  /* height: 26px; */\r\n  width: 100%;\r\n}\r\n\r\n.imageDiv {\r\n  /* border: 3px solid rgb(128, 0, 128); */\r\n  /* display: flex; */\r\n  /* display: flex; */\r\n  /* justify-content: center; */\r\n  margin: 0 auto;\r\n  width: 100%;\r\n  max-width: 800px;\r\n  /* opacity: 0; */\r\n}\r\n\r\n.image800 {\r\n  width: 100%;\r\n  max-width: 800px;\r\n}\r\n\r\n.imageDiv {\r\n  /* border: 3px solid rgb(128, 0, 128); */\r\n  /* display: flex; */\r\n  /* display: flex; */\r\n  /* justify-content: center; */\r\n  margin: 0 auto;\r\n  width: 100%;\r\n  max-width: 900px;\r\n}\r\n\r\n.image800r {\r\n  width: 100%;\r\n  max-width: 800px;\r\n\r\n  float: left;\r\n  margin-right: 5px;\r\n  margin-bottom: 5px;\r\n  /* background-color: #ffffff; */\r\n  -moz-border-radius: 8px;\r\n  -webkit-border-radius: 8px;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),\r\n    0 0 30px rgba(0, 0, 0, 0.1) inset;\r\n  -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),\r\n    0 0 30px rgba(0, 0, 0, 0.1) inset;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 30px rgba(0, 0, 0, 0.1) inset;\r\n  padding: 0;\r\n}\r\n\r\n.imageDiv500 {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin: 0 auto;\r\n  width: 100%;\r\n  max-width: 800px;\r\n}\r\n\r\n.image500 {\r\n  /* border: 3px solid rgb(128, 0, 128); */\r\n  width: 100%;\r\n  height: 100%;\r\n  max-width: 400px;\r\n\r\n  float: left;\r\n  margin-right: 5px;\r\n  margin-bottom: 5px;\r\n  /* background-color: #ffffff; */\r\n  -moz-border-radius: 8px;\r\n  -webkit-border-radius: 8px;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),\r\n    0 0 30px rgba(0, 0, 0, 0.1) inset;\r\n  -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),\r\n    0 0 30px rgba(0, 0, 0, 0.1) inset;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 30px rgba(0, 0, 0, 0.1) inset;\r\n  padding: 0;\r\n}\r\n\r\n.imageDiv600 {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin: 0 auto;\r\n  width: 100%;\r\n  max-width: 600px;\r\n}\r\n\r\n.image600 {\r\n  /* border: 3px solid rgb(128, 0, 128); */\r\n  width: 100%;\r\n  height: 100%;\r\n  max-width: 600px;\r\n\r\n  float: left;\r\n  margin-right: 5px;\r\n  margin-bottom: 5px;\r\n  /* background-color: #ffffff; */\r\n  -moz-border-radius: 8px;\r\n  -webkit-border-radius: 8px;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),\r\n    0 0 30px rgba(0, 0, 0, 0.1) inset;\r\n  -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),\r\n    0 0 30px rgba(0, 0, 0, 0.1) inset;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 30px rgba(0, 0, 0, 0.1) inset;\r\n  padding: 0;\r\n}\r\n\r\n.imageHalf {\r\n  width: 49.5%;\r\n  padding: 1px;\r\n  height: 50%;\r\n  max-width: 400px;\r\n}\r\n\r\n\r\n\r\n.imageHalf450b {\r\n  width: 50%;\r\n  /* padding: 1px; */\r\n  height: 50%;\r\n  max-width: 450px;\r\n\r\n  float: left;\r\n  margin-left: 2px;\r\n  margin-bottom: 5px;\r\n  /* background-color: #ffffff; */\r\n  -moz-border-radius: 8px;\r\n  -webkit-border-radius: 8px;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),\r\n    0 0 30px rgba(0, 0, 0, 0.1) inset;\r\n  -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),\r\n    0 0 30px rgba(0, 0, 0, 0.1) inset;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 30px rgba(0, 0, 0, 0.1) inset;\r\n  padding: 0;\r\n}\r\n\r\n.imageSix {\r\n  width: 13%;\r\n  padding: 1px;\r\n  height: 15%;\r\n  max-width: 136px;\r\n}\r\n\r\n.imageFour {\r\n  width: 49.5%;\r\n  padding: 1px;\r\n  height: 50%;\r\n  max-width: 200px;\r\n}\r\n\r\n.divHalf {\r\n  /* border: 3px solid rgb(0, 128, 85); */\r\n  overflow: hidden;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.divHalf2 {\r\n  /* border: 3px solid rgb(0, 128, 85); */\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.divHalf3 {\r\n  /* border: 3px solid rgb(0, 128, 85); */\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: justify;\r\n}\r\n\r\n.textDivPrint {\r\n  /* border: 3px solid rgb(128, 0, 128); */\r\n  /* position: absolute; */\r\n  /* padding-left: 12px; */\r\n  /* padding-right: 12px; */\r\n\r\n  margin-top: 12px;\r\n  margin-bottom: 12px;\r\n  text-align: center;\r\n  max-width: 800px;\r\n  width: 100%;\r\n}\r\n\r\n.textDivPrint2 {\r\n  margin-top: 12px;\r\n  margin-bottom: 12px;\r\n  text-align: justify;\r\n  text-align-last: center;\r\n  max-width: 800px;\r\n  width: 100%;\r\n}\r\n\r\n.textDivPrint3 {\r\n  margin: 0 auto;\r\n  margin-top: 12px;\r\n  margin-bottom: 12px;\r\n  text-align: center;\r\n  /* text-align-last: center; */\r\n  max-width: 800px;\r\n  width: 100%;\r\n}\r\n\r\n\r\n.textDi2 {\r\n  /* border: 3px solid rgb(128, 0, 128); */\r\n  /* position: absolute; */\r\n  margin-left: 12px;\r\n  margin-right: 12px;\r\n  margin-top: 7px;\r\n  margin-bottom: 0px;\r\n  text-align: justify;\r\n}\r\n\r\n.textDivDark {\r\n  /* border: 3px solid rgb(128, 0, 128); */\r\n  /* position: absolute; */\r\n  background-color: #333333;\r\n  color: #cccccc;\r\n  padding-left: 12px;\r\n  padding-right: 12px;\r\n  padding-top: 7px;\r\n  padding-bottom: 7px;\r\n  text-align: justify;\r\n}\r\n\r\n\r\n\r\n.textDivCenter3 {\r\n  /* border: 3px solid rgb(128, 0, 128); */\r\n  /* position: absolute; */\r\n  width: 50%;\r\n  margin-left: 12px;\r\n  margin-right: 12px;\r\n  text-align: center;\r\n}\r\n\r\n.textDivCenter4 {\r\n  /* border: 3px solid rgb(128, 0, 128); */\r\n  /* position: absolute; */\r\n  width: 50%;\r\n  /* margin-left: 12px; */\r\n  margin-right: 12px;\r\n  text-align: justify;\r\n}\r\n\r\n.textDivCenter2 {\r\n  /* border: 3px solid rgb(128, 94, 0); */\r\n  background-color: #333333;\r\n  padding-top: 12px;\r\n  padding-bottom: 12px;\r\n  width: 50%;\r\n  text-align: center;\r\n}\r\n\r\n.greyLine2 {\r\n  width: 100%;\r\n  height: 1px;\r\n  background-color: rgb(150, 150, 150);\r\n}\r\n\r\n.greyLineBrowser {\r\n  /* border: 3px solid rgb(128, 94, 0); */\r\n  width: 900px;\r\n  /* width: 100%; */\r\n  height: 1px;\r\n  /* padding-bottom: 1px; */\r\n  background-color: rgb(150, 150, 150);\r\n}\r\n\r\n.iframeDiv {\r\n  position: relative;\r\n  padding-bottom: 56.25%;\r\n  height: 0;\r\n  width: 100%;\r\n  max-width: 900px;\r\n}\r\n\r\n.iframeVid {\r\n  /* border: 2px soldid; */\r\n  /* border-style: inset; */\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.videoCont {\r\n  display: flex;\r\n  margin: 0 auto;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  justify-content: top;\r\n}\r\n\r\n.videoDiv {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 578px;\r\n  max-width: 900px;\r\n\r\n  /* float: left;\r\n  margin-right: 5px;\r\n  margin-bottom: 5px;\r\n  background-color: #ffffff;\r\n  -moz-border-radius: 8px;\r\n  -webkit-border-radius: 8px;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),\r\n    0 0 30px rgba(0, 0, 0, 0.1) inset;\r\n  -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3),\r\n    0 0 30px rgba(0, 0, 0, 0.1) inset;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 30px rgba(0, 0, 0, 0.1) inset;\r\n  padding: 0; */\r\n}\r\n\r\n.oldDiv {\r\n  top: 110px;\r\n  height: 25px;\r\n  width: 100%;\r\n  padding-top: 4px;\r\n  /* position: absolute; */\r\n  /* border: 3px solid rgb(128, 0, 128); */\r\n  background-color: black;\r\n  color: white;\r\n  text-align: center;\r\n}\r\n\r\n#videoCont {\r\n  display: flex;\r\n  margin: 0 auto;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  justify-content: top;\r\n}\r\n\r\n#videoDiv {\r\n  position: relative;\r\n  width: 100%;\r\n  /* height: 578px; */\r\n  height: 506px;\r\n  max-width: 900px;\r\n  /* border: 3px solid rgb(128, 0, 128); */\r\n}\r\n\r\n#video {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n@media (max-width: 700px) {\r\n  #videoDiv {\r\n    position: absolute;\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n@media (max-width: 400px) {\r\n  .divHalf {\r\n    /* display: block; */\r\n    flex-direction: column;\r\n  }\r\n  .textDivPrint3 {\r\n    width: 95%;\r\n  }\r\n  .textDivCenter4 {\r\n    margin-top: 10px;\r\n  }\r\n  .serif13Waking {\r\n    font-size: 11px;\r\n  }\r\n  .imageHalf {\r\n    width: 100%;\r\n    max-width: 400px;\r\n    padding: 0px;\r\n    padding-top: 1px;\r\n  }\r\n  .imageHalf450 {\r\n    width: 100%;\r\n    max-width: 450px;\r\n    margin: 0px;\r\n    padding: 0px;\r\n    padding-top: 1px;\r\n    border-radius: 0px;\r\n    border-radius: 0px;\r\n    margin-right: 0px;\r\n    margin-bottom: 2px;\r\n    -moz-border-radius: 0px;\r\n    -webkit-border-radius: 0px;\r\n    border-radius: 0px;\r\n  }\r\n  .imageHalf450b {\r\n    width: 100%;\r\n    max-width: 450px;\r\n    margin: 0px;\r\n    padding: 0px;\r\n    padding-top: 1px;\r\n    border-radius: 0px;\r\n    border-radius: 0px;\r\n    margin-right: 0px;\r\n    margin-bottom: 2px;\r\n    -moz-border-radius: 0px;\r\n    -webkit-border-radius: 0px;\r\n    border-radius: 0px;\r\n  }\r\n  .textDivPrint2 {\r\n    display: none;\r\n  }\r\n  .image800r {\r\n    border-radius: 0px;\r\n    border-radius: 0px;\r\n    margin-right: 0px;\r\n    margin-bottom: 2px;\r\n    -moz-border-radius: 0px;\r\n    -webkit-border-radius: 0px;\r\n    border-radius: 0px;\r\n  }\r\n  .image500 {\r\n    border-radius: 0px;\r\n    margin-right: 0px;\r\n    margin-bottom: 0px;\r\n    -moz-border-radius: 0px;\r\n    -webkit-border-radius: 0px;\r\n    border-radius: 0px;\r\n  }\r\n  .image600 {\r\n    border-radius: 0px;\r\n    margin-right: 0px;\r\n    margin-bottom: 2px;\r\n    -moz-border-radius: 0px;\r\n    -webkit-border-radius: 0px;\r\n    border-radius: 0px;\r\n  }\r\n  \r\n  .shadBox {\r\n    border: 0px;\r\n    border-style: none;\r\n  }\r\n  .textDivPrint {\r\n    padding-left: 10px;\r\n    /* padding-right: 12px; */\r\n    width: 95%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
